import client from 'api/client';
import { AxiosRequestConfig } from 'axios';

export function get(id: number, customConfig?: AxiosRequestConfig) {
    const url = `payment_receipt/${id}`;
    return client.get<{ url: string }>(url, customConfig);
}
